import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { TabContents } from '../../2_Molecules/Tabs/TabContents'
import { handleRequest } from '../../../utils/httpRequest'
import Jelly from '../../2_Molecules/Jelly/Jelly'
import { getEndpointUrl } from '../../../utils/endPoints'
import { languageController } from '../../../controllers/language/languageController'
import { stripHTML } from '../../../utils/helpers'

function SelectVehicle({
  onSelectVehicle,
  preDefinedModelId
}) {
  const [vehicles, setVehicles] = useState(null)

  useEffect(() => {
    const loadVehicles = async () => {
      try {
        const res = await handleRequest('get', getEndpointUrl('model-years'))
        if (res.status === 200 && res.data) {
          setVehicles(res.data)
        } else {
          console.log('Error: ', res.message)
        }
      } catch (err) {
        console.log('Error: ', err);
      }
    }
    loadVehicles()
  }, [])

  // Get all the previous models of vehicles.
  const getPreviousModelVehicles = (vehicles) => {
    return vehicles.filter(vehicle => vehicle.previous_model && !vehicle.is_coming_soon);
  }

  // Generate an image path for jelly.
  const generateImageSrc = (vehicleData, isHover = false) => {
    if (!vehicleData || !vehicleData.visual) return '';
    const { static_content_base_path, jelly_path, jelly, jelly_hover } = vehicleData.visual;
    return static_content_base_path + jelly_path + (isHover ? jelly_hover : jelly);
  }

  const createTabs = (vehicles) => {
    if (!vehicles) return null;

    const { categories, model_years } = vehicles;
    // Filter out the previous models.
    const nonPrevModelYears = model_years.filter(model => !model.previous_model);

    return Object.keys(categories).map(key => {
      let futureVehicles = [];
      // Get vehicles of the category AND available (not coming soon)
      const vehiclesOfCategoty = nonPrevModelYears.filter(model => {
        // Check if it is the category type.
        const isMatched = model.carline.categories.some(category => category.id === categories[key].id);
        // Return if not matched.
        if (!isMatched) return false;
        // If it's coming soom, return false and assign it to futureVehicles.
        if (model.is_coming_soon) {
          futureVehicles = [...futureVehicles, model];
          return false;
        }
        return true;
      });

      if (!vehiclesOfCategoty.length > 0) return '';

      return ({
        id: categories[key].title,
        tabTitle: categories[key].title,
        tabContent: [...vehiclesOfCategoty, ...futureVehicles].map(vehicleData => {
          return (
            <Jelly
              key={vehicleData.id}
              carName={vehicleData.carline.title}
              carModel={stripHTML(vehicleData.description)}
              carPrice={vehicleData.financial.msrp}
              onClick={() => {
                if (vehicleData.is_coming_soon) return;
                onSelectVehicle(vehicleData)
              }}
              topLabel={vehicleData.coming_soon_data?.top_copy}
              isInactive={vehicleData.is_coming_soon}
              carImageSrc={generateImageSrc(vehicleData)}
              carImageHoverSrc={generateImageSrc(vehicleData, true)}
              isSelected={(vehicleData.id === preDefinedModelId)}
            />
          )
        })
      })
    })
  }

  return (
    <div className="mz-select-vehicle">
      {
        vehicles && (
          <TabContents
            dataTabs={[
              ...createTabs(vehicles)/*,
              {
                id: 'previous',
                tabTitle: languageController.getCopy('global', 'previous'),
                tabContent: getPreviousModelVehicles(vehicles.model_years).map(vehicleData => {
                  return (
                    <Jelly
                      key={vehicleData.id}
                      carName={vehicleData.year.title + ' ' + vehicleData.carline.title}
                      carModel={stripHTML(vehicleData.description)}
                      carPrice={vehicleData.financial.msrp}
                      onClick={() => onSelectVehicle(vehicleData)}
                      isSelected={(vehicleData.id === preDefinedModelId)}
                      carImageSrc={generateImageSrc(vehicleData)}
                      carImageHoverSrc={generateImageSrc(vehicleData, true)}                      
                    />
                  )
                })
              }*/
            ]}
            defaultTab={vehicles.categories[Object.keys(vehicles.categories)[0]].title}
          />
        )
      }
    </div>
  )
}

SelectVehicle.propTypes = {
  onSelectVehicle: PropTypes.func.isRequired,
  preDefinedModelId: PropTypes.string,
}

export default SelectVehicle